module.exports = __webpack_public_path__ + "static/assets/be26c6db73dc514ce7ce0bb83cf95af9.png";